import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { subscribePageLoading } from './PageLoadingService';

function PageLoading({ theme, language, busy = false }) {
    const [pendingRequests, setPendingRequests] = useState(0);
    const [visible, setVisible] = useState(false);
    const loading = busy || pendingRequests > 0;
    const light = theme === 'light';

    useEffect(() => subscribePageLoading(setPendingRequests), []);

    useEffect(() => {
        if (!loading) {
            setVisible(false);
            return;
        }
        // Quick requests should not flash a loading card.
        const timer = setTimeout(() => setVisible(true), 180);
        return () => clearTimeout(timer);
    }, [loading]);

    if (!visible || typeof document === 'undefined') return null;

    return createPortal(
        <div role="status" aria-live="polite" style={{
            position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
            zIndex: 1000000, pointerEvents: 'none', width: 'max-content',
            maxWidth: 'calc(100vw - 40px)', padding: '20px 28px',
            backgroundColor: light ? '#eaeaea' : '#3e4349',
            color: light ? '#222' : '#fff', borderRadius: 5,
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.2)',
            display: 'flex', alignItems: 'center', gap: 16,
            fontFamily: 'Lato, Arial, sans-serif', fontSize: 16,
        }}>
            <style>{`
                @keyframes tbp-page-loading-spin { to { transform: rotate(360deg); } }
            `}</style>
            <span aria-hidden="true" style={{
                width: 26, height: 26, flexShrink: 0, borderRadius: '50%',
                border: '3px solid rgba(177, 177, 177, 0.4)',
                borderTopColor: light ? '#555' : '#fff',
                animation: 'tbp-page-loading-spin 0.8s linear infinite',
            }} />
            <span>{language === 'spanish' ? 'Cargando…' : 'Loading…'}</span>
        </div>,
        document.body
    );
}

export default PageLoading;
